import { Clazz, User, Syllabus } from "../types";
import ResourceService from "../common/Services/ResourceService";

class ClazzService extends ResourceService<Clazz> {
  constructor() {
    super({
      path: "/clazzes",
      queryKey: "clazzes",
    });
  }

  static listClazzes() {
    return new ClazzService().list();
  }

  static fetchClazz(id: Clazz["id"]) {
    return new ClazzService().fetch({ id });
  }

  static createClazz(payload: Partial<Clazz>) {
    return new ClazzService().create(payload);
  }

  static updateClazz(id: Clazz["id"], payload: Partial<Clazz>) {
    return new ClazzService().update({ ...payload, id });
  }

  static deleteClazz(id: Clazz["id"]) {
    return new ClazzService().deleteOne({ id });
  }

  static joinClazz(code: string) {
    return new ClazzService().joinClazz({ code });
  }

  static removeClazzMember(id: Clazz["id"], userId: User["id"]) {
    return new ClazzService().removeClazzMember({ id, userId });
  }

  static listClazzRoster(id: Clazz["id"]) {
    return new ClazzService().listClazzRoster({ id });
  }

  static listClazzSyllabi(id: Clazz["id"]) {
    return new ClazzService().listClazzSyllabi({ id });
  }

  joinClazz({ code }: { code: string }): Promise<Clazz> {
    return this.post([code, "join"]);
  }

  removeClazzMember({
    id,
    userId,
  }: Pick<Clazz, "id"> & { userId: User["id"] }): Promise<void> {
    return this.post([id, "roster", userId]);
  }

  listClazzRoster({ id }: Pick<Clazz, "id">): Promise<User[]> {
    return this.get([id, "roster"]);
  }

  listClazzSyllabi({ id }: Pick<Clazz, "id">): Promise<Syllabus[]> {
    return this.get([id, "syllabi"]);
  }
}

export default ClazzService;
